angular.module('property-deal')
    .controller('PropertyDealSelectController', function ($http, $scope, $rootScope, $uibModalInstance, data, modals, PropertyDeal, PropertyDealService) {
        this.filters = data;
        this.PropertyDealService = PropertyDealService

        this.$onInit = () => {
            this.loadData();
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.select = selected => {
            return modals.confirm("Czy na pewno chcesz połączyć?", () => {
                $uibModalInstance.close(selected);
            })
        }

        this.loadData = () => {
            let filters = angular.copy(this.filters);
            PropertyDeal.tableStatistics(filters).$promise.then(result => {
                this.statistics = result
                this.statuses = Object.keys(result.status)
            })
            PropertyDeal.table(filters).$promise.then(result => {
                this.items = result;
            })
        }
    })
